
<template>
	<page>
		<module>
			<view-list
				ref="view"
				work-type="21"
				selector
			>
				<template #search>
					<m-search ref="search">
						<m-search-item label="背贴码">
							<m-code-batch-input name="produce_unique_codes" field-name="背贴码" placeholder="请输入背贴码，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="IMEI">
							<m-code-batch-input name="produce_imeis" field-name="IMEI" placeholder="请输入IMEI，支持批量"></m-code-batch-input>
						</m-search-item>
						<m-search-item label="产品信息">
							<c-input name="product_name"></c-input>
						</m-search-item>
						<m-search-item label="借货人">
							<c-select name="borrower_id" async @search="searchBorrower"></c-select>
						</m-search-item>
						<m-search-item label="借出时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button v-if="auth('b_loan_list_create')" prepend-icon="tf-add" @click="createLend">新建借出</c-button>
					<c-button v-if="auth('b_loan_list_return')" prepend-icon="tf-return-back" @click="batchReturn()">批量归还</c-button>
					<c-button v-if="auth('b_loan_list_export')" prepend-icon="tf-export" @click="exportLendList()">导出</c-button>
				</template>

				<template #product_info="{data}">
					<m-product-info :name="data.product_info || getProductText(data)" :level="data.level_type" :code="data.produce_unique_code" :imei="data.produce_imei"></m-product-info>
				</template>

				<template #produce_unique_code="{data}">
					{{data.produce_unique_code}} <c-link color="gray" @click="$copy(data.produce_unique_code)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #produce_imei="{data}">
					{{data.produce_imei}} <c-link v-if="data.produce_imei" color="gray" @click="$copy(data.produce_imei)"><i class="tf">&#xe6b0;</i></c-link>
				</template>

				<template #market_price="{data}">
					<span style="color: #e53e3e;">{{formatPrice(data.market_price)}}</span>
				</template>

				<template #return_state="{data}">
					<c-state dict="saleReturnStateDic" :value="data.return_state"></c-state>
				</template>

				<template #lend_days="{data}">
					{{data.lend_days}}天
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="100"
					button-limit="6"
				>
					<template #default="{data}">
						<c-table-button v-if="auth('b_loan_list_return')" :disabled="data.return_state == 2" icon="tf-return-back" @click="returnLend(data)">归还</c-table-button>
					</template>
				</c-table-column>
			</view-list>
		</module>
	</page>
</template>

<script>
	import CState from "@/components/public/state.vue";

    export default {
        components: {CState},
		methods: {
			/*********搜索借货人**********/
			searchBorrower(keyword, resolve) {
				this.request({
					url: '/sale/customer/options',
					data: {
						keyword: keyword
					},
					success: data => {
						resolve((data || []).map(item => {
							return {
								name: item.customer_name,
								value: item.id
							};
						}));
					}
				});
			},

			/*********导出借出列表**********/
			exportLendList() {
				var search = this.$refs.search ? this.$refs.search.get() : {};
				this.request({
					url: '/sale/lend/export/url',
					data: Object.assign({
						view_id: this.$refs.view.getViewId()
					}, search),
					success: data => {
						if (data && data.url) {
							window.open(data.url);
						}
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********获取产品信息文字**********/
			getProductText(data) {
				var parts = [];
				if (data.brand_name) parts.push(data.brand_name);
				if (data.model_name) parts.push(data.model_name);
				if (data.memory_name) parts.push(data.memory_name);
				if (data.color_name) parts.push(data.color_name);
				return parts.join(' ') || '-';
			},

			/*********新建借出**********/
			createLend() {
				this.globalDialog('saleLendEdit', {}, () => {
					this.$refs.view.update();
				});
			},

			/*********批量归还**********/
			batchReturn(list) {
				this.globalDialog('saleLendReturn', {}, () => {
					this.$refs.view.update();
				});
			},

			/*********单个归还**********/
			returnLend(data) {
				this.$confirm({
					message: '确认归还该借出记录吗？',
					buttonName: '确定',
					cancelButton: true,
					resolve: () => {
						this.request({
							url: '/sale/lend/return',
							data: {
								lend_product_id: data.id
							},
							loading: true,
							success: (data, msg) => {
								this.$message({message: msg, type: 'success'});
								this.$refs.view.update();
							}
						});
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-product-info {
		line-height: 24px;
		font-size: 13px;
		color: #333;

		.m-product-info-name {
			display: flex;
			align-items: center;
			gap: 4px;
		}
	}
</style>
